import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceBatchPoolDocHdrContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_batch_pool_doc_hdr_container.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared/api-response.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { EInvoiceSearchDto } from '../../data-transfer-objects';
import { MyEInvoiceSearchResultContainer } from '../../../../../models/aggregates/e-invoice/my-einvoice-search-result-container.model';


@Injectable({
  providedIn: 'root'
})
export class BatchPoolPostToProcessService extends BaseApiPublicLoginTemplateService<MyEInvoiceBatchPoolDocHdrContainerModel, MyEInvoiceBatchPoolDocHdrContainerModel, MyEInvoiceBatchPoolDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-doc-hdrs'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-doc-hdrs'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-doc-hdrs'
    this.httpClient = http;
  }

  postMultipleToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/process-batch-pools/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  searchEinvoice(dtoObject: EInvoiceSearchDto, visa: ApiVisa): Observable<ApiResponseModel<MyEInvoiceSearchResultContainer>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      let apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = apiUrl + "/search-e-invoice/login-ep";
    }

    return this.httpClient.post<ApiResponseModel<MyEInvoiceSearchResultContainer>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  skipEinvoice(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-doc-hdrs/skip-e-invoice/backoffice-ep';
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pool-doc-hdrs/skip-e-invoice/backoffice-ep';
    }

    return this.httpClient.delete<ApiResponseModel<any>>(
      customUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

}
